// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"e_teb","title":"e_ueb","container":"e_veb","list":"e_web"};